import React from 'react';
import type { IntlShape } from 'react-intl-next';
import { defineMessages } from 'react-intl-next';

import type { ADFEntity } from '@atlaskit/adf-utils/types';
import Image from '@atlaskit/image';
import { fg } from '@atlaskit/platform-feature-flags';

import type { HubElement } from '../hub-element-placeholder/config-panel/hubElementType';

import { carouselExtensionKey, carouselExtensionType } from './carouselConstants';
import carouselHubElementThumbnail from './carouselHubElementThumbnail.svg';
import carouselHubElementThumbnailDark from './carouselHubElementThumbnail-dark.svg';
import { carouselParameters } from './carouselManifest';

const i18n = defineMessages({
	carouselTitle: {
		id: 'custom-sites-extensions.carousel.hub-element.title',
		defaultMessage: 'Carousel',
		description: 'A visible text label to be used as the title for the carousel element',
	},
	carouselDescription: {
		id: 'custom-sites-extensions.carousel.hub-element.description',
		defaultMessage: 'A rotating set of beautiful frames',
		description: 'A visible text label to be used as the description for the carousel element',
	},
});

const getDefaultCarouselNodeAdf = (intl: IntlShape): ADFEntity => {
	const { formatMessage } = intl;

	return {
		type: 'extension',
		attrs: {
			extensionKey: carouselExtensionKey,
			extensionType: carouselExtensionType,
			parameters: carouselParameters(
				formatMessage(i18n.carouselTitle),
				intl,
				fg('company_hub_carousel_v2'),
			),
		},
	};
};
const thumbnailImage: React.ReactNode = (
	<Image src={carouselHubElementThumbnail} srcDark={carouselHubElementThumbnailDark} alt="" />
);

export const carouselHubElement: HubElement = {
	extensionKey: carouselExtensionKey,
	title: i18n.carouselTitle,
	description: i18n.carouselDescription,
	Image: thumbnailImage,
	// @todo set update lozenge to false after release https://hello.jira.atlassian.cloud/browse/COMPHUB-3150
	hasUpdatedLozenge: true,
	getNodeAdf: getDefaultCarouselNodeAdf,
};
